// extracted by mini-css-extract-plugin
export default {"container":"vP-z","darkBackground":"wP-z","whiteBackground":"xP-z","headerButton":"yP-z","calloutHeading":"zP-z","calloutSubHeading":"AP-z"};